(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-genesis"]) return;
  try {
    
  class GenesisNav extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('#genesis-nav-panel');
      this.overlay = this.querySelector('.genesis-nav-overlay');
      this.hamburger = this.querySelector('.genesis-header__hamburger');
      this.closeBtn = this.querySelector('.genesis-nav-panel__close');
      this._isOpen = false;
      this._focusableEls = [];
      this._firstFocusable = null;
      this._lastFocusable = null;
      this._boundOnKeyDown = this._onKeyDown.bind(this);
    }

    connectedCallback() {
      if (!this.panel || !this.hamburger) return;
      this.hamburger.addEventListener('click', () => this.open());
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
    }

    open() {
      this._isOpen = true;
      this.panel.setAttribute('aria-hidden', 'false');
      this.hamburger.setAttribute('aria-expanded', 'true');
      if (this.overlay) {
        this.overlay.classList.add('genesis-nav-overlay--visible');
      }
      document.body.style.overflow = 'hidden';
      document.body.classList.add('genesis-nav-open');

      // Focus trap setup
      this._focusableEls = Array.from(
        this.panel.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
      this._firstFocusable = this._focusableEls[0];
      this._lastFocusable = this._focusableEls[this._focusableEls.length - 1];

      document.addEventListener('keydown', this._boundOnKeyDown);

      // Focus the close button after transition
      requestAnimationFrame(() => {
        if (this.closeBtn) this.closeBtn.focus();
      });
    }

    close() {
      this._isOpen = false;
      this.panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('genesis-nav-open');
      this.hamburger.setAttribute('aria-expanded', 'false');
      if (this.overlay) {
        this.overlay.classList.remove('genesis-nav-overlay--visible');
      }
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._boundOnKeyDown);
      this.hamburger.focus();
    }

    _onKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      if (this._focusableEls.length === 0) return;

      if (event.shiftKey) {
        if (document.activeElement === this._firstFocusable) {
          event.preventDefault();
          this._lastFocusable.focus();
        }
      } else {
        if (document.activeElement === this._lastFocusable) {
          event.preventDefault();
          this._firstFocusable.focus();
        }
      }
    }
  }

  if (!customElements.get('genesis-nav')) {
    customElements.define('genesis-nav', GenesisNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
